import { KeyDrop } from "@pdfking/tfunc"

import { is_null } from "./is_null"
import { to_array } from "./to_array"

export const key_drop = (data, to_drop) => {
  if (is_null(to_drop)) return data
  return KeyDrop(data, to_array(to_drop))
}
